import React from 'react';

import styles from './LoadingAnimation.scss';

const LoadingAnimation = ({ size, type }) => {
  const dots = [];
  for (let i = 0; i < 6; i++) {
    dots.push(<div className="LoadingAnimation__dot" key={`dot-${i}`} />);
  }
  const typeClass = type ? `LoadingAnimation--${type}` : '';
  return (
    <div
      className={`LoadingAnimation LoadingAnimation--${size ||
        'medium'} ${typeClass}`}
    >
      {type === 'tiny' ? dots.slice(0, 3) : dots}
    </div>
  );
};

export default LoadingAnimation;
